import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DefaultComponent } from "src/app/default.component";

export enum LOADER_TYPE {
  SPINNER,
  PULSE,
}
@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrl: "./loader.component.less",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinnerModule],
})
export class LoaderComponent extends DefaultComponent {
  @Input()
  public type: LOADER_TYPE;

  public constructor() {
    super();
    this.type = LOADER_TYPE.SPINNER;
  }
}
